import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginLayoutRoutes } from '../../../custom/layouts/local-login-layout/login-layout.routing';
import { LoginLayoutComponent } from './login-layout.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(LoginLayoutRoutes),
  ],
  declarations: [
    LoginLayoutComponent
  ],
  exports: [
    LoginLayoutComponent
  ]

})
export class LoginLayoutModule {
 }
